import MembershipsSoldContainer from "@/Reports/MembershipsSoldContainer.vue";

export default [
  {
    path: "/memberships",
    name: "MembershipsSoldContainer",
    component: MembershipsSoldContainer,
    meta: {
      permissionRoles: ["customers"]
    }
  }
];
